var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 253,
    viewBox: "0 0 525 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0518 0H525V186.015V199.087V201.645V214.474V217.762V252.959V253.041H118.247L115.728 250.524C77.1653 211.997 38.5623 173.43 0 134.904V0H34.0518ZM2.4787 35.9689C4.26666 34.1826 6.05457 32.3963 7.84253 30.6101V43.4387L2.4787 48.7975V51.3145L7.84253 45.9557V59.0279L2.4787 64.3867V133.686C41.4474 172.618 80.416 211.551 119.385 250.483H259.005L264.45 245.043H277.535L272.09 250.483H274.609L280.054 245.043H292.895L287.45 250.483H290.172L295.617 245.043H308.702L303.257 250.483H305.776L311.221 245.043H324.062L318.616 250.483H460.432L465.877 245.043H478.961L473.516 250.483H476.035L481.48 245.043H494.321L488.876 250.483H492.167L522.44 220.238V216.95C520.652 218.736 518.864 220.522 517.076 222.309V209.48L522.44 204.121V201.604L517.076 206.963V193.891L522.44 188.532V31.4626L493.508 2.51701H265.873L260.509 7.8758H247.425L252.788 2.51701H250.269L244.905 7.8758H232.065L237.428 2.51701H234.706L229.342 7.8758H216.258L221.621 2.51701H219.102L213.738 7.8758H200.898L206.262 2.51701H64.5685L59.2047 7.8758H46.1204L51.4841 2.51701H48.9648L43.601 7.8758H30.7605L36.1242 2.51701H31.6544L2.60065 31.5438V36.0095L2.4787 35.9689Z",
    fill: "#4083E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxR);
export default __webpack_public_path__ + "static/media/box_r.6889ab161dd511383f1e4c56296438c9.svg";
export { ForwardRef as ReactComponent };